import type {Context} from 'react'
import {createContext} from 'react'

import {BuildApprovalViewMode} from './BuildApproval.types'

export const BuildApprovalViewContext: Context<BuildApprovalViewMode> =
  createContext<BuildApprovalViewMode>(BuildApprovalViewMode.INLINE)
